module.exports = __webpack_public_path__ + "static/media/priorbank.4cc7f0a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/priorbank.png
// module id = 316
// module chunks = 0